<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{'relatorioVeiculos.controleProposta.dealers'}}
                </div>
                <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtrosDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                  {{dealer.nome}}
                  <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
                </span>
                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <hr>
            <div class="row ptb50 align-items-end" [formGroup]="form">
              <div class="col col-3">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'relatorioVeiculos.controleProposta.dataInicial'}}
                </div>
                <p-calendar formControlName="data_inicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true"
                  (onClearClick)="limpaDataInicial()" (onSelect)="onSelectDataInicial($event)" [monthNavigator]="true" yearRange="2000:2030"
                  placeholder="{{'relatorioVeiculos.controleProposta.dataInicialPlaceHolder' | translate}}"
                  showButtonBar="true">
                </p-calendar>
              </div>
              <div class="col col-3">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'relatorioVeiculos.controleProposta.dataFinal'}}
                </div>
                <p-calendar formControlName="data_final" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" (onClearClick)="limpaDataFinal()" (onSelect)="onSelectDataFinal($event)"
                  placeholder="{{'relatorioVeiculos.controleProposta.dataFinalPlaceHolder' | translate}}"
                  showButtonBar="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030">
                </p-calendar>
              </div>
              <div class="col col-2">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'relatorioVeiculos.controleProposta.tipo_data'}}
                </div>
                <p-dropdown appendTo="body"
                  placeholder="{{'relatorioVeiculos.controleProposta.tipo_dataPlaceHolder' | translate }}"
                  [options]="tipoDataOptions" optionLabel="name" optionValue="value" formControlName="tipo_data"
                  [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
                </p-dropdown>
              </div>
              <div class="col col-4 d-flex align-items-end justify-content-end">
                <button translate type="button" class="btn btn-primary mt-3 mr-2" (click)="filtroAPI()">
                  {{'relatorioVeiculos.controleProposta.filtrar'}}
                  <i class="fas fa-search"></i>
                </button>
                <button [class.btn-info]="!getListagemComFiltros()" [class.btn-warning]="getListagemComFiltros()"
                  translate class="btn mt-3" type="button" (click)="exibirFiltro()">
                  {{'relatorioVeiculos.controleProposta.maisFiltros'}}
                  <em class="fa fa-filter"></em>
                </button>
                <button pButton class="p-button-outlined p-button-secondary p-button-sm float-right mt-3" type="button"
                  (click)="exportExcel()">
                  <i class="fa fa-download mr-1"></i>Export Excel
                </button>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
    </div>

    <!-- Carga Inicial da tela -->
    <div class="d-flex justify-content-center">
      <div *ngIf="cargaTela == true">
        <div class="w-100 d-flex justify-content-center mt-4">
          <p-progressSpinner></p-progressSpinner>
        </div>
        <div class="w-100 d-flex justify-content-center">
          <label>Loading...</label>
        </div>
      </div>
    </div>

    <div translate *ngIf="dados?.length <= 0 && cargaTela == false" class="sem-registros text-muted mt-2">
      {{'rmpv.detalhado.nenhumRegistroExibir'}}
    </div>

    <p-table #dt *ngIf="dados?.length > 0" [value]="dados" dataKey="idProposta" selectionMode="single"
      styleClass="p-datatable-responsive-demo p-datatable-striped p-datatable-sm" [columns]="selectedColumns"
      [paginator]="dados?.length > 10" [rows]="10" [loading]="loading" [columns]="cols" [autoLayout]="true"
      [rowHover]="true" [scrollable]="true"  
      currentPageReportTemplate="{{'relatorioVeiculos.controleProposta.mostrandoRegistros' | translate}}"
      [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50,100]" [globalFilterFields]="['codDealer','dealer','nome','chassi','marca',
        'modelo','valorVenda','valor','corExterna','anoModelo','situacao','status','numeroProposta','data','documento','DDD','telefone','email']" id="excel-table">
      <ng-template pTemplate="colgroup" let-columns>
        <colgroup *ngFor="let col of columns">
          <col [style.width]="col.width">          
        </colgroup>
      </ng-template>
      <ng-template pTemplate="caption">
        <div class="table-header">
          <span class="p-input-icon-left mr-1">
            <i class="pi pi-search"></i>
            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
              placeholder="{{'relatorioVeiculos.controleProposta.filtroGeral' | translate}}" />
          </span>

          <p-multiSelect *ngIf="this.translate.currentLang == 'br'" [options]="cols" [(ngModel)]="selectedColumns"
            optionLabel="headerBr"
            selectedItemsLabel="{{'relatorioVeiculos.controleProposta.colunasSelecionadas' | translate}}"
            [style]="{minWidth: '200px'}"
            placeholder="{{'relatorioVeiculos.controleProposta.colunasSelecionadasPlaceHolder' | translate}}">
          </p-multiSelect>
          <p-multiSelect *ngIf="this.translate.currentLang == 'gb'" [options]="cols" [(ngModel)]="selectedColumns"
            optionLabel="headerGb"
            selectedItemsLabel="{{'relatorioVeiculos.controleProposta.colunasSelecionadas' | translate}}"
            [style]="{minWidth: '200px'}"
            placeholder="{{'relatorioVeiculos.controleProposta.colunasSelecionadasPlaceHolder' | translate}}">
          </p-multiSelect>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of columns">
            <th class="text-center" [class.valor-direita]="col.field === 'valorVenda' || col.field === 'valor'" style="background-color:black;color:white;" [pSortableColumn]="col.field">
              {{ this.translate.currentLang == 'br' ? col.headerBr : col.headerGb }}
              <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="" />
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-dados let-columns="columns">
  <tr>
    <ng-container *ngFor="let col of columns">
      <td class="text-center" [class.valor-direita]="col.field === 'valorVenda' || col.field === 'valor'">

        <ng-container *ngIf="col.field === 'valor'; else emissaoDisplay">
          <span *ngIf="propostaCancelada(dados)">{{ dados.valor }}</span>
          <a *ngIf="!propostaCancelada(dados)" class="link-pagamentos" href="javascript:;"
            (click)="abrirPagamentos(dados); $event.preventDefault(); $event.stopPropagation()"
            [title]="'relatorioVeiculos.controleProposta.verPagamentos' | translate">
            {{ dados.valorVenda || '-' }}
          </a>
        </ng-container>

        <ng-template #emissaoDisplay>
        <!-- Emissão da Proposta -->
        <ng-container *ngIf="col.field === 'emissaoProposta'; else dataVendaDisplay">
          <ng-container *ngIf="(dados.emissaoProposta | date:'HH:mm:ss') !== '00:00:00'; else onlyDateEmissao">
            {{ dados.emissaoProposta | date:'dd/MM/yyyy HH:mm:ss' }}
          </ng-container>

          <ng-template #onlyDateEmissao>
            {{ dados.emissaoProposta | date:'dd/MM/yyyy' }}
          </ng-template>
        </ng-container>

        <!-- Data da Venda -->
        <ng-template #dataVendaDisplay>
          <ng-container *ngIf="col.field === 'dataVenda'; else defaultDisplay">
            {{ dados.dataVenda || '-' }}
          </ng-container>
        </ng-template>

        <!-- Demais campos -->
        <ng-template #defaultDisplay>
          {{ dados[col.field] || '-' }}
        </ng-template>
        </ng-template>

        <ng-container *ngIf="col.field === 'status'" [translate]="getTranslate(dados)"></ng-container>

      </td>
    </ng-container>
  </tr>
</ng-template>
      
    </p-table>
  </div>
</div>

<p-dialog header="Definir filtros" [(visible)]="displayFiltros" [style]="{width: '550px'}" [modal]="true"
  [draggable]="false">
  <form [formGroup]="form">
    <div class="container striped-rows">
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.controleProposta.filtros.grupoEconomico'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.controleProposta.filtros.grupoEconomicoPlaceHolder' | translate }}"
            [options]="gruposEconomicos" optionLabel="descricao" optionValue="id" formControlName="grupo_economico"
            [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.controleProposta.filtros.chassi'}}
        </div>
        <div class="col col-8">
          <input class="form-control form-control-sm" type="text"
            placeholder="{{'relatorioVeiculos.controleProposta.filtros.chassiPlaceHolder' | translate }}"
            formControlName="chassi">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.controleProposta.filtros.numeroProposta'}}
        </div>
        <div class="col col-8">
          <input class="form-control form-control-sm" type="text"
            placeholder="{{'relatorioVeiculos.controleProposta.filtros.numeroPropostaPlaceHolder' | translate }}"
            formControlName="numeroProposta">
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.veiculoVendido.filtros.status'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.veiculoVendido.filtros.tipoPlaceHolder' | translate }}" [options]="tipo"
            optionLabel="nome" optionValue="valor" formControlName="tipo" [autoDisplayFirst]="false"
            [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">           
          </p-dropdown>
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.controleProposta.filtros.situacao'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.controleProposta.filtros.situacaoPlaceHolder' | translate }}" [options]="situacao"
            optionLabel="nome" optionValue="valor" formControlName="situacao" [autoDisplayFirst]="false"
            [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">           
          </p-dropdown>
        </div>
      </div>
      <div class="row ptb5">
        <div translate class="col col-4">
          {{'relatorioVeiculos.veiculoVendido.filtros.vendaDireta'}}
        </div>
        <div class="col col-8">
          <p-dropdown appendTo="body"
            placeholder="{{'relatorioVeiculos.veiculoVendido.filtros.vendaPlaceHolder' | translate }}"
            [options]="vendaDireta" optionLabel="nome" optionValue="valor" formControlName="vendaDireta"
            [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
          </p-dropdown>
        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-outline-primary" (click)="limparFiltros()">
      <i class="fa fa-trash" aria-hidden="true"></i>
    </button>
    <button translate type="button" class="btn btn-info"
      (click)="filtroAPI()">{{'relatorioVeiculos.controleProposta.filtrar'}}</button>
  </ng-template>
</p-dialog>

<!-- <p-dialog header="{{'relatorioVeiculos.controleProposta.selecioneDealers' | translate}}"
  [(visible)]="displayFiltrosDealers" [style]="{width: '800px'}" [modal]="true" [draggable]="false">
  <div class="d-flex flex-wrap">
    <ng-container *ngFor="let item of filtrosDealers.naoSelecionados()">
      <span class="btn btn-primary btn-sm itemListaSelecao" style="font-size: 14px; margin: 2px;"
        (click)="onAdicionarDealerFiltro(item)">
        {{item.toTexto()}}
      </span>
    </ng-container>
  </div>
</p-dialog> -->

<!-- Componente modular para filtro de dealers -->
<app-filtro-dealers
  [(visible)]="displayFiltrosDealers"
  [dealers]="filtrosDealers.dealers"
  [headerTitle]="'relatorioVeiculos.controleProposta.selecioneDealers'"
  [filterPlaceholder]="'relatorioVeiculos.controlePedidos.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>

<p-dialog
  [(visible)]="displayPagamentos"
  [modal]="true"
  [style]="{ width: '90vw', maxWidth: '1100px' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="fecharPagamentos()">
  <ng-template pTemplate="header">
    <span>
      {{ 'relatorioVeiculos.controleProposta.tituloPagamentos' | translate }}
      <ng-container *ngIf="propostaSelecionada?.numeroProposta">
        — {{ propostaSelecionada.numeroProposta }}
      </ng-container>
    </span>
  </ng-template>

  <div *ngIf="propostaSelecionada?.valorVenda" class="mb-3 text-muted">
    {{ 'relatorioVeiculos.controleProposta.gridHeader.precoVenda' | translate }}: {{ propostaSelecionada.valorVenda }}
  </div>

  <div *ngIf="loadingPagamentos" class="d-flex justify-content-center my-4">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div *ngIf="!loadingPagamentos && erroPagamentos" class="sem-registros text-muted mt-2">
    {{ erroPagamentos }}
  </div>

  <div *ngIf="!loadingPagamentos && !erroPagamentos && pagamentos.length === 0" class="sem-registros text-muted mt-2">
    {{ 'relatorioVeiculos.controleProposta.nenhumPagamento' | translate }}
  </div>

  <div *ngIf="!loadingPagamentos && !erroPagamentos && pagamentos.length > 0" class="d-flex justify-content-end mb-2">
    <button pButton class="p-button-outlined p-button-secondary p-button-sm" type="button"
      (click)="exportExcelPagamentos()">
      <i class="fa fa-download mr-1"></i>Exportar Excel
    </button>
  </div>

  <p-table
    *ngIf="!loadingPagamentos && !erroPagamentos && pagamentos.length > 0"
    [value]="pagamentos"
    styleClass="p-datatable-striped p-datatable-sm"
    [autoLayout]="true">
    <ng-template pTemplate="header">
      <tr>
        <th class="text-center" style="background-color:black;color:white;">
          {{ 'relatorioVeiculos.controleProposta.gridHeader.dealer' | translate }}
        </th>
        <th class="text-center" style="background-color:black;color:white;">
          {{ 'relatorioVeiculos.controleProposta.gridHeader.chassi' | translate }}
        </th>
        <th class="text-center" style="background-color:black;color:white;">
          {{ 'relatorioVeiculos.controleProposta.gridHeader.numeroProposta' | translate }}
        </th>
        <th class="text-center" style="background-color:black;color:white;">
          {{ 'relatorioVeiculos.controleProposta.tipoPagto' | translate }}
        </th>
        <th class="text-center" style="background-color:black;color:white;">
          {{ 'relatorioVeiculos.controleProposta.descricaoPagamento' | translate }}
        </th>
        <th class="text-center" style="background-color:black;color:white;">
          {{ 'relatorioVeiculos.controleProposta.valor' | translate }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-pagamento>
      <tr>
        <td class="text-center">{{ pagamento.dealer || '-' }}</td>
        <td class="text-center">{{ pagamento.chassi || '-' }}</td>
        <td class="text-center">{{ pagamento.numeroProposta || '-' }}</td>
        <td class="text-center">{{ pagamento.descTipoPagto || pagamento.tipoPagto || '-' }}</td>
        <td class="text-center">{{ pagamento.descricao || '-' }}</td>
        <td class="text-right">{{ pagamento.valor | number:'1.2-2':'pt-BR' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="footer">
      <tr>
        <td colspan="5" class="text-right font-weight-bold">
          {{ 'relatorioVeiculos.controleProposta.totalPagamentos' | translate }}
        </td>
        <td class="text-right font-weight-bold">
          {{ valorPagamentos | number:'1.2-2':'pt-BR' }}
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div *ngIf="!loadingPagamentos && !erroPagamentos && pagamentos.length === 0" class="text-right font-weight-bold mt-3">
    {{ 'relatorioVeiculos.controleProposta.totalPagamentos' | translate }}:
    {{ valorPagamentos | number:'1.2-2':'pt-BR' }}
  </div>
</p-dialog>

<p-toast key="rmpvDetalhado" position="bottom-right"></p-toast>
